import { TaskEnumBreakAdjustment } from '../enum';

export const BREAK_ADJUSTMENT_FOR_APPROVE_TASK_TYPE = TaskEnumBreakAdjustment.BREAKADJUSTMENTALERTFORAPPROVE;

export const BREAK_ADJUSTMENT_FOR_APPROVE_ROUTE = 'break-adjustment-for-approval';

export const DEFAULT_COUNTED_UNITS = 0;

export const getCountedUnits = (item?: any): number => {
    if (!item) return DEFAULT_COUNTED_UNITS;
    return (
        item.countedUnits ??
        item.product?.countedUnits ??
        item.meta_data?.product?.countedUnits ??
        item.metadata?.product?.countedUnits ??
        DEFAULT_COUNTED_UNITS
    );
};

export const getManagerName = (item?: any): string => {
    if (!item) return '—';
    const createdBy =
        item.createdBy ??
        item.created_by ??
        item.product?.createdBy ??
        item.product?.created_by ??
        item.metadata?.createdBy ??
        item.metadata?.created_by ??
        item.meta_data?.createdBy ??
        item.meta_data?.created_by;

    if (typeof createdBy === 'string' && createdBy.trim() !== '') {
        return createdBy;
    }
    if (createdBy && typeof createdBy === 'object') {
        const name = createdBy.name || createdBy.full_name || createdBy.email;
        if (name && typeof name === 'string' && name.trim() !== '') return name;
    }

    const manager =
        item.managerName ??
        item.manager_name ??
        item.product?.managerName ??
        item.metadata?.managerName ??
        item.meta_data?.managerName;

    if (manager && typeof manager === 'string' && manager.trim() !== '') {
        return manager;
    }

    return '—';
};
